import React from 'react'
import './Candidate.scss'

const Candidate = () => {
  return (
    <div>Candidate</div>
  )
}

export default Candidate